import { defineStore } from 'pinia';
import { useRefreshStore } from '@/common/composables/refreshStore';
import { useListPackages, type ListPackagesResponse } from '../api/listPackages';
import { usePackageStore } from 'shared/packages/stores/packageStore';

export const useRefreshPackageStore = defineStore('refresh-packages', () => {
  const listPackages = useListPackages();
  const store = usePackageStore();

  const { initialize, refresh } = useRefreshStore<ListPackagesResponse>({
    fetchFromServer() {
      return listPackages.execute();
    },
    mergeToStore(response) {
      store.clear();
      store.merge(response.packages);
    },
  });

  return {
    initialize,
    refresh,
  };
});
